import { getAPI } from 'src/utils/api';
import checkAuthError from '../utils/checkAuthError';

import { notification } from 'antd';
import i18n from 'i18next';

notification.config({
	placement: 'topRight',
	top: 75,
	duration: 2,
});

const createComments = async (commentsToCreate) => {
	try {
		const api = await getAPI();
		const { data } = await api.post(`comments/new`, { commentsToCreate });

		notification.success({
			message: i18n.t('comments.note-comments-created', '*Comments created'),
			description: i18n.t(''),
		});
		return data;
	} catch (error) {
		checkAuthError(error);

		notification.error({
			message: i18n.t('notifications.onSaveError'),
			description: error.message,
		});
		console.log(error.response);
	}
};

const getAllComments = async () => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`comments/all`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.log(error.response);
	}
};

const updateComments = async (commentsId, comment, action, activityToAdd) => {
	try {
		const api = await getAPI();

		let response;
		switch (action) {
			case 'edit': {
				response = await api.put(`comments/${commentsId}`, { commentToEdit: comment, activityToAdd });
				break;
			}
			case 'new': {
				response = await api.post(`comments/${commentsId}`, { commentToCreate: comment, activityToAdd });
				break;
			}
			case 'delete': {
				response = await api.delete(`comments/${commentsId}/${comment._id}`);
				break;
			}
			case 'activity': {
				response = await api.post(`comments/${commentsId}/activity`, { activityToAdd });
				break;
			}
		}

		const { data } = response;

		if (action !== 'activity') {
			notification.success({
				message: i18n.t('comments.note-comments-edited', '*Comments updated'),
				description: i18n.t(''),
			});
		}

		return data;
	} catch (error) {
		checkAuthError(error);

		notification.error({
			message: i18n.t('comments.note-comments-edit-error', 'comments could not be updated'),
			description: error.message,
		});
		console.log(error.response);
	}
};

export { createComments, getAllComments, updateComments };
